import React, { type FC } from 'react'
import { DataListHeader, PaginationBar, NoResults } from 'mailup-web-components'
import { useIntl } from 'react-intl'
import { useAtom } from 'jotai'
import { useAtomCallback } from 'jotai/utils'
import { categoriesPagedListAtom, categoriesQueryAtom } from '../state/state'
import {
  changeCategoriesFieldOrdering,
  changeCategoriesPage,
  changeCategoriesPageSize,
} from '../callbacks/categories'
import { CategoryRow } from './CategoryRow'
import { COL_SPAN } from '../helpers/constants'

export const CategoriesList: FC = () => {
  const intl = useIntl()

  const [categoriesPage] = useAtom(categoriesPagedListAtom)
  const [query] = useAtom(categoriesQueryAtom)
  const categoriesList = categoriesPage.Items
  const handleChangePage = useAtomCallback(changeCategoriesPage)
  const handleChangePageSize = useAtomCallback(changeCategoriesPageSize)
  const handleChangeColumnsOrder = useAtomCallback(
    changeCategoriesFieldOrdering,
  )

  const heads = [
    {
      field: 'Id',
      label: intl.formatMessage({ id: 'Load.MailupCommon.Id' }),
      span: COL_SPAN.ID,
      sortable: true,
    },
    {
      field: 'Name',
      label: intl.formatMessage({ id: 'Load.MailupCommon.Name' }),
      span: COL_SPAN.NAME,
      sortable: true,
    },
    {
      field: 'Actions',
      span: COL_SPAN.ACTIONS,
      sortable: false,
    },
  ]

  return categoriesPage.TotalItems === 0 ? (
    <NoResults
      text={intl.formatMessage({
        id: 'Load.Common.NoResultChosen',
      })}
    />
  ) : (
    <>
      <DataListHeader
        heads={heads}
        orderByStatus={query.orderBy}
        orderDescendingStatus={query.orderDescending}
        handleChangeColumnsOrderCallback={handleChangeColumnsOrder}
      />
      <div>
        {categoriesList.map((category) => (
          <CategoryRow key={category.Id} category={category} />
        ))}
      </div>
      <PaginationBar
        pageNumber={categoriesPage.PageNumber}
        pageSize={categoriesPage.PageSize}
        totalItems={categoriesPage.TotalItems}
        handleChangePage={handleChangePage}
        handleChangePageSize={handleChangePageSize}
      />
    </>
  )
}
